const PRODUCT_MANAGEMENT = [
  {
    path: 'product-management/category',
    name: 'ProductManagementCategory',
    component: () => import('@/views/product-management/category'),
    meta: {
      title: '产品品类',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/brand',
    name: 'ProductManagementBrand',
    component: () => import('@/views/product-management/brand'),
    meta: {
      title: '产品品牌',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/spu',
    name: 'ProductManagementSpu',
    component: () => import('@/views/product-management/SPU'),
    meta: {
      title: 'SPU管理',
      icon: '',
      keepAlive: true,
    },
  },
  // {
  //   path: 'product-management/info',
  //   name: 'ProductManagementInfo',
  //   component: () => import('@/views/product-management/product-info/index_backup.vue'),
  //   meta: {
  //     title: '产品资料',
  //     icon: '',
  //     keepAlive: true,
  //   },
  // },

  {
    path: 'product-management/info-new',
    name: 'ProductManagementInfoNew',
    component: () => import('@/views/product-management/product-info'),
    meta: {
      title: '产品资料New',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/custom-info',
    name: 'ProductManagementCustomInfo',
    component: () => import('@/views/product-management/custom-info'),
    meta: {
      title: '关务信息',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/price',
    name: 'ProductManagementPrice',
    component: () => import('@/views/product-management/product-price'),
    meta: {
      title: '产品价格',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/leader',
    name: 'ProductManagementLeader',
    component: () => import('@/views/product-management/product-leader'),
    meta: {
      title: '产品负责人',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/project',
    name: 'ProductManagementProject',
    component: () => import('@/views/product-management/project-management/index.vue'),
    meta: {
      title: '项目管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'product-management/attachment',
    name: 'ProductManagementAttachment',
    component: () => import('@/views/product-management/attachment-management/index.vue'),
    meta: {
      title: '附件管理',
      icon: '',
      keepAlive: true,
    },
  },
]
export default PRODUCT_MANAGEMENT
